import { Component, EventEmitter, Output, TemplateRef, ViewChild } from "@angular/core";
import { NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";
import { GenderOptions } from "src/app/core/constants/constants";

@Component({
  selector: "app-booking-vehicle-filter-modal",
  templateUrl: "./booking-vehicle-filter-modal.component.html",
  styleUrl: "./booking-vehicle-filter-modal.component.scss",
  standalone: false
})
export class BookingVehicleFilterModalComponent {
  accessibilityList: Array<any> = [];
  vehicleCapacityList: Array<any> = [];

  appliedfilterDetails: any;
  countrySetting: any;
  selectedCapacity!: number | null;
  selectedGender: any;
  selectedSpeakingLanguage: any;

  allowNoOfSeatSelection!: boolean;

  GenderOptions = GenderOptions;

  @Output() onApplyFilter = new EventEmitter<any>();

  @ViewChild("bookingVehicleFilterModal", { static: true }) bookingVehicleFilterModal!: TemplateRef<any>;

  constructor(public offcanvasService: NgbOffcanvas) {}

  /**
   * Opens the modal dialog with the provided filter details and settings.
   *
   * @param appliedfilterDetails The details of the applied filters.
   * @param countrySetting The country-specific settings.
   * @param accessibilityList The list of accessibility options.
   * @param vehicleCapacityList The list of vehicle capacity options.
   * @param allowNoOfSeatSelection Flag indicating if seat selection is allowed.
   */
  openModal({
    appliedfilterDetails,
    countrySetting,
    accessibilityList,
    vehicleCapacityList,
    allowNoOfSeatSelection
  }: {
    appliedfilterDetails: any;
    countrySetting: any;
    accessibilityList: Array<any>;
    vehicleCapacityList: Array<any>;
    allowNoOfSeatSelection: boolean;
  }): void {
    this.vehicleCapacityList = vehicleCapacityList;
    this.appliedfilterDetails = appliedfilterDetails;
    this.selectedCapacity = this.appliedfilterDetails?.selectedCapacity ?? null;
    this.selectedGender = this.appliedfilterDetails?.selectedGender ?? null;
    this.selectedSpeakingLanguage = this.appliedfilterDetails?.selectedSpeakingLanguage ?? null;
    this.countrySetting = countrySetting;
    this.allowNoOfSeatSelection = allowNoOfSeatSelection;

    this.manageAccessibility(accessibilityList);

    this.offcanvasService.open(this.bookingVehicleFilterModal, { position: "end", panelClass: "modal-right-lg" })?.result.then(
      () => {},
      () => {}
    );
  }

  /**
   * Closes the currently open modal dialog.
   */
  closeModal(): void {
    this.offcanvasService.dismiss(this.bookingVehicleFilterModal);
  }

  /**
   * Manages the accessibility options by updating their checked status based on the applied filter details.
   *
   * @param accessibilityList The list of accessibility options.
   */
  manageAccessibility(accessibilityList: Array<any>): void {
    this.accessibilityList = accessibilityList;
    this.accessibilityList.forEach((accessibility) => {
      accessibility.isChecked = false;
      if (this.appliedfilterDetails?.accessibilityIds?.includes(accessibility._id)) {
        accessibility.isChecked = true;
      }
    });
  }

  /**
   * Handles the change event for accessibility options.
   *
   * @param event The change event object.
   * @param accessibility The accessibility option being changed.
   */
  onChangeAccessibility(event: any, accessibility: any): void {
    accessibility.isChecked = event.target.checked;
  }

  /**
   * Applies the selected filters and emits the filtered data.
   */
  applyFilter(): void {
    const filteredData: any = {
      accessibilityIds: this.accessibilityList.filter((data: any) => data.isChecked).map((data: any) => data._id),
      selectedCapacity: this.selectedCapacity,
      selectedGender: this.selectedGender,
      selectedSpeakingLanguage: this.selectedSpeakingLanguage
    };

    this.onApplyFilter.emit(filteredData);
    this.closeModal();
  }

  /**
   * Clears all the applied filters and resets the filter details.
   */
  clearFilter(): void {
    this.appliedfilterDetails = null;
    this.selectedCapacity = null;
    this.selectedGender = null;
    this.selectedSpeakingLanguage = null;
    this.manageAccessibility(this.accessibilityList);
  }
}
